// extracted by mini-css-extract-plugin
module.exports =  {"colorSampleList":"UuXCve"};